module.exports = __webpack_public_path__ + "img/BE0404453574.5fe53188.svg";